








import Vue from 'vue'
import '@/assets/scss/_global.scss'

export default Vue.extend({
  name: 'App'
})
